function join(
  s1: string | undefined,
  s2: string | undefined,
  separator: string,
): string {
  return !s1 || !s2
    ? s1 || s2 || ""
    : `${s1}${s1.endsWith(separator) ? "" : separator}${s2}`;
}

export function joinPaths(
  path1: string | undefined,
  path2: string | undefined,
): string {
  return join(path1, path2, "/");
}

export function joinPackages(
  pkg1: string | undefined,
  pkg2: string | undefined,
): string {
  return join(pkg1, pkg2, ".");
}
